module.exports = __webpack_public_path__ + "media/images/menu/deimos-85f979846fd0b32b7045168b06f3d762.jpg";